import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnDestroy, AfterViewInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchRecord, VendorResponseTypes, SearchVendors, SearchPackage, CriminalSearchTypes } from '../../models/searchPackage';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ClientPackagePricing } from '../../models/clientPackagePrice';
import { ScreeningAdditionalData } from 'src/app/models/screeningInvite';
import { CriminalRecord } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { LocationData } from '../../models/locationData';

@Component({
  selector: 'app-search-add-dialog',
  templateUrl: './search-add-dialog.component.html',
  styleUrls: ['./search-add-dialog.component.less']
})
export class SearchAddDialogComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() public search : SearchRecord;
  @Input() public existingPackage : SearchPackage;
  @Input() public clientPackageOverrides : ClientPackagePricing;
  @Output() searchAdded = new EventEmitter<SearchRecord>();
  @Input() packageEditMode: boolean;
  @Input() canAddTieredSearch: boolean = false;
  @Input() iscountyAutoMode : boolean = false;
  @Input() isStateAutoMode : boolean = false;
  @Input() additionalData : ScreeningAdditionalData[];
  @Input() autoPopulateRecord : CriminalRecord;
  searchInPackage: boolean = false;

  saveSearchSub$ : Subscription;
  countiesLoaded$ : Subscription;
  @ViewChild('form',{}) ngForm: NgForm;
  formChangesSubscription : Subscription;
  _isCustomSearch : boolean;
  _isTieredSearch : boolean;
  phase : number = 0;
  _filteredSearches : SearchRecord[] = [];

  public get hasDefaultPrice(): boolean {
    return this.search.searchType == VendorResponseTypes.EvictionVerification 
        || (this.search.searchType == VendorResponseTypes.Criminal && 
          this.search.searchMeta.searchDepth != CriminalSearchTypes.National)
  }

  public get showCallPatternDD(): boolean {
    if(this.search.vendor == 4 && this.search.searchType != VendorResponseTypes.EvictionVerification) return true;
    return false;
  }

  public get showCountyDD(): boolean {
    return (this.search.name.includes('County') || this.search.searchType == VendorResponseTypes.EvictionVerification) && this.search.searchMeta.state;
  }

  public get showStateDD(): boolean { 
    return (this.search.name.includes('State') || this.search.name.includes('County') || this.search.searchType == VendorResponseTypes.EvictionVerification);
  }


  constructor(public modalService: NgbModal,
    public searches : SearchPackageService,
    public auth : AuthService,
    public toast : ToastrService) { 
      this._filteredSearches = [];
      this.searches.searchesSupported.filter(s => !s.restrictedForClientId.includes(this.auth.loggedInUser.clientId)).forEach(srch => {
        this._filteredSearches.push(Object.assign(new SearchRecord(),JSON.parse(JSON.stringify(srch))));
      });
  }

  ngAfterViewInit(): void {
    this.search.cost = 0.00;
    this.ngForm.form.valueChanges.subscribe();
    if(this.iscountyAutoMode && this.search.searchType == VendorResponseTypes.Criminal){
      this.isCustomSearch = false;
      this.search = this._filteredSearches.find(srch =>{ return srch.searchType == VendorResponseTypes.Criminal && srch.searchMeta.searchDepth == CriminalSearchTypes.County; });
      if(this.hasDefaultPrice){
       
        this.search.cost = 6.00;
      }
    }
    if(this.isStateAutoMode)
    {
      this.search = this._filteredSearches.find(srch =>{ return srch.searchType == VendorResponseTypes.Criminal && srch.searchMeta.searchDepth == CriminalSearchTypes.SingleState; });
      this.search.searchMeta.state = this.autoPopulateRecord.state;
      if(this.hasDefaultPrice){
        if(this.search.searchMeta.searchDepth == CriminalSearchTypes.UtahDistrictCourtScrape || this.search.searchMeta.searchDepth == CriminalSearchTypes.UtahJusticeCourtScrape)
          this.search.cost = 3.00;
        else 
          this.search.cost = 6.00;
      }
    }
    if(this.search.searchType == VendorResponseTypes.EvictionVerification) {
      this.search.cost = 6.00;
    }
    // console.log('AfterViewInit Complete',this.search);

  }
  ngOnDestroy(): void {
   this.search,this.existingPackage,this.clientPackageOverrides,this.searchAdded,this.packageEditMode,this.additionalData = undefined;
   if(this.saveSearchSub$) this.saveSearchSub$.unsubscribe();
   if(this.countiesLoaded$) this.countiesLoaded$.unsubscribe();
   this.searches._stateData = undefined;
  }

  ngOnInit() {
    if(this.iscountyAutoMode)
    {
      if(this.search.searchType == VendorResponseTypes.Criminal) this.searches.loadStateData(this.autoPopulateRecord.state);
      if(this.search.searchType == VendorResponseTypes.EvictionVerification) this.searches.loadStateData(this.search.searchMeta.state);
    }

    this.countiesLoaded$ = this.searches.stateDataLoaded.subscribe(()=>{
      if(this.iscountyAutoMode){
        if(this.search.searchType == VendorResponseTypes.Criminal){
        this.search.searchMeta.state = this.autoPopulateRecord.state;
        this.search.searchMeta.county = this.searches.stateData.find(r => r.countyName.toUpperCase() == this.autoPopulateRecord.duplicateJurisdictionToCheck.toUpperCase())?.countyName ?? null;
        // this.search.searchdataLocation = this.searches.stateData.find(sd =>{return sd.stateAbbr == this.autoPopulateRecord.state && sd.countyName.toUpperCase() == this.autoPopulateRecord.duplicateJurisdictionToCheck;});
        // console.log('setup search', this.search);
        // console.log(this.autoPopulateRecord)
      } 
      else if (this.search.searchType == VendorResponseTypes.EvictionVerification){
        this.search.searchMeta.state = this.search.searchMeta.state.toUpperCase();
        this.search.searchMeta.county = this.search.searchMeta.county.toUpperCase();
      }   
    }});
    // SCRSTP-1402 : processing Logic
    // console.log('Init Complete',this.search);
  }

  
  public set isCustomSearch(v : boolean) {
    if(v){
      this.search.name = '--'; 
      this.search.searchMeta = {};
    }
    this. _isCustomSearch= v;
  }
  
  
  public get isCustomSearch() : boolean {
    return this._isCustomSearch;
  }
  
  
  public get canSetPrice() : boolean {
    if(!this.existingPackage) {
      return true;
    }
    else 
      return !this.existingPackage.searchInPackage(this.search);
  }
  
  updateCreditVendor()
  {
    if(this.search.vendor == SearchVendors.Equifax){
      this.search.includeFICO = false;
      this.search.searchMeta.repository = 0;
    }
    else if(this.search.vendor == SearchVendors.Transunion)
    {
      this.search.searchMeta.repository = 2;
    }
    // console.log('Credit Search Vendor updated',this.search)
  }

  phaseUp(){
    this.phase++;
    if(this.phase == 1 && !this.canAddTieredSearch) this.phase++;
    // console.log('phasing up',this.search);
  }

  //SCRSTP-1380: only show searches that the currently logged in user has access to.
  public get filteredSearches() : SearchRecord[] {
    return this._filteredSearches;
  }

  getcountiesforState(state : string): Array<string>{
    return this.searches.stateData?.filter(sd =>{return sd.stateAbbr == state}).map(s =>{return s.countyName.toUpperCase();});
  }

  
  public get counties() : LocationData[] {
    if(this.search.searchMeta.state)
      return this.searches.stateData?.filter(sd =>{return sd.stateAbbr == this.search.searchMeta.state})
    else return []
  }
  

  save(){
    if(this.existingPackage && this.existingPackage.searchInPackage(this.search) && this.packageEditMode){

        this.toast.error(`${this.search.name} is already included in this package`);
        this.modalService.dismissAll();
        return;
      }

    if(this.ngForm.valid){
      if(this.isCustomSearch){
        this.search.searchType = VendorResponseTypes.CustomSearch;
        this.search.vendor = SearchVendors.Custom;
        
      }
      this.saveSearchSub$ = this.searches.saveSearch(this.search).subscribe((scc: any)=>{
        if(scc){
          this.toast.success(`Search Saved Successfully, Id : ${scc}`);
          this.search.id = scc;
          this.searchAdded.emit(this.search);
        }
        else
          this.toast.error('Error Saving Search');
        this.cancel();
      },(err: any)=>{
        this.toast.error('Error Saving Search');
      })
    }
  }

  public get manualTriggerLock() : boolean {
    return !(this.search.searchType === VendorResponseTypes.Eviction && this.search.vendor === SearchVendors.Cleara);
  }

  cancel(){
    this.modalService.dismissAll();
  }

  stateSet(srch : SearchRecord){
    this.searches.loadStateData(srch.searchMeta.state);
  }

  countySet(srch : SearchRecord){
    // console.log('setting county for search', srch);
  }

  // handles search selection
  onChange(srch: SearchRecord){
    srch.isTieredSearch = this._isTieredSearch;
    if(srch.isTieredSearch){
      srch.includedInBundledPrice = false;
      srch.searchesIncludedInBundledPrice = 1;
      srch.isManualTrigger = true;
      // this.existingPackage
      
    }
    if(this.packageEditMode && !this._isTieredSearch)srch.includedInBundledPrice = true; // This is only ever called when adding a new search. and ALL new searches are included in the bundle by default : 1592
    // console.log('search set' ,srch);
    // then we need to try and setup the search. if the search is already included in the package then we need to show the client override price if exists.. else the regular cost after bundle.
    if(this.existingPackage && this.existingPackage.searchInPackage(this.search)){
      if(this.packageEditMode){
        this.toast.error(`${srch.name} is already included in this package`);
        this.modalService.dismissAll();
      }
      this.searchInPackage = true;
      let original = this.existingPackage.searches.find(sr=>{return sr.searchType == this.search.searchType && sr.vendor == this.search.vendor && this.search.name == sr.name});
      if(original){
        // is there a client override for this?
        let override = this.clientPackageOverrides.searchOverrides.find(spo=>{return spo.searchRecordId == original.id});
        if(override){
          this.search.cost = override.clientSearchCost;
        }else{
          this.search.cost = original.cost;
        }

        // if this is the add a search to report scenario then we need to check the screening addtlData and set it as included in bundle proce based on the existing numbers.
        if(this.additionalData.filter(addy => {return addy.searchName == this.search.name}).length >= original.searchesIncludedInBundledPrice) this.search.includedInBundledPrice = false;
        else this.search.includedInBundledPrice = true;
        // we dont store notes on the override
        this.search.processingNotes = original.processingNotes
      }
    }
    if(this.hasDefaultPrice){
      if(this.search.searchMeta.searchDepth == CriminalSearchTypes.UtahDistrictCourtScrape || this.search.searchMeta.searchDepth == CriminalSearchTypes.UtahJusticeCourtScrape)
      this.search.cost = 3.00;
    else 
      this.search.cost = 6.00;
      
    }
  }
}
